import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { TreeItemLayout } from '@fluentui/react-components/unstable'
import { Badge, FlatTreeItem, useRestoreFocusTarget } from '@fluentui/react-components'
import { bundleIcon, DocumentFilled, DocumentRegular, FolderOpenFilled, FolderRegular } from '@fluentui/react-icons'
import FormattedDateTime from '../Date/FormattedDateTime'
import { DocumentFlatTreeItemProps } from './DocumentFlatTree'

const DocumentIcon = bundleIcon(DocumentFilled, DocumentRegular)

export default function SimpleDocumentFlatTreeItem(props: DocumentFlatTreeItemProps): ReactElement {
    const focusTargetAttribute = useRestoreFocusTarget()

    const isFolder = useMemo(() => props.itemType === 'branch', [props.item])
    const isFile = useMemo(() => props.itemType === 'leaf', [props.item])
    const isOpen = useMemo(() => {
        return [...props.flatTreeHook.getTreeProps().openItems].some(id => id === props.value)
    }, [props.item, props.flatTreeHook.getTreeProps().openItems])

    return (
        <FlatTreeItem {...props} {...focusTargetAttribute}>
            <TreeItemLayout
                iconBefore={isFolder ? isOpen ? <FolderOpenFilled /> : <FolderRegular /> : <DocumentIcon />}
                iconAfter={
                    isFolder && (
                        <Badge size={'small'} appearance={'tint'}>
                            {props.item.childCount}
                        </Badge>
                    )
                }
                aside={isFile && <FormattedDateTime date={props.item.lastModifiedDateTime} />}
            >
                {props.item.displayName}
            </TreeItemLayout>
        </FlatTreeItem>
    )
}
